/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'

//import deflogo from '../../assets/thinkleadEcosystem.jpg'
import deflogo from '../../assets/mevision01.png'

const styles = theme => ({
  root: {
    width: 250,
    backgroundColor: '#fff',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer', // Add pointer cursor to indicate clickability
    transition: 'opacity 0.2s ease', // Smooth hover effect
    '&:hover': {
      opacity: 0.8 // Slight opacity change on hover
    }
  }
})

class Companylogo extends Component {
  state = {
    companylogo: deflogo,
    logoLoaded: false
  };

  // Handle logo click to navigate to dashboard
  handleLogoClick = () => {
    this.props.history.push('/');
  };

  componentWillMount() {
    let url_test_app = window.location.href
    let url_live_app = window.location.origin

    let url = checkUserDomain(url_test_app)

    let corporateLogos = {
      'https://oneconnect.thinklead.co.za':
        'https://firebasestorage.googleapis.com/v0/b/glp-corporate.appspot.com/o/photos%2Foneconnect.png?alt=media&token=884d27c0-235e-4867-8242-45efbb02a760',
      //'https://blsa.thinklead.co.za':
       // 'https://firebasestorage.googleapis.com/v0/b/glp-corporate.appspot.com/o/photos%2Fblsa-logo-online.jpg?alt=media&token=021df841-e4f6-4235-844d-775181cd559f',
      'https://edcon.thinklead.co.za':
        'https://firebasestorage.googleapis.com/v0/b/glp-corporate.appspot.com/o/photos%2Fedcon.png?alt=media&token=665ff538-a1ea-492c-b357-a69fadd9053a',
      'http://127.0.0.1:8081':
        'https://firebasestorage.googleapis.com/v0/b/glp-corporate.appspot.com/o/photos%2Foneconnectsolutions.png?alt=media&token=21401e9a-68cc-424a-a491-dd41b83808db',
      'https://glp-test-f6590.appspot.com':
        'https://firebasestorage.googleapis.com/v0/b/glp-corporate.appspot.com/o/photos%2Foneconnectsolutions.png?alt=media&token=21401e9a-68cc-424a-a491-dd41b83808db',
      'https://harmony.thinklead.co.za':
        'https://firebasestorage.googleapis.com/v0/b/leadershipplatform-158316.appspot.com/o/companyLogos%2Fthumbnail.png?alt=media&token=5749af48-dd93-4c2f-9759-c865954ceea9'
    }

    let src = corporateLogos[url] || deflogo
    //let src = deflogo

    // Load the corporate logo immediately
    this.setState(state => ({
      companylogo: src
    }))

    function checkUserDomain(uri) {
      let corporates = [
        'edcon.co.za',
        'edcon@',
        'edcon',
        'oneconnect.co.za',
        'oneconnect@',
        'oneconnect',
        //'blsa.org.za',
        //'blsa@',
        //'businessleadership.org.za',
        //'businessleadership@',
        //'businessleadership',
        //'blsa',
        'harmony@',
        'harmony'
      ]

      for (let x = 0; x < corporates.length; x++) {
        let y = corporates[x]
        let patt = new RegExp(y)

        if (patt.test(uri)) {
          let corporateDomains = {
            'oneconnect.co.za': 'https://oneconnect.thinklead.co.za',
            'oneconnect@': 'https://oneconnect.thinklead.co.za',
            'oneconnect': 'https://oneconnect.thinklead.co.za',
            'edcon.co.za': 'https://edcon.thinklead.co.za',
            'edcon': 'https://edcon.thinklead.co.za',
            'edcon@': 'https://edcon.thinklead.co.za',
            //'blsa.org.za': 'https://blsa.thinklead.co.za',
            //'blsa': 'https://blsa.thinklead.co.za',
            //'blsa@': 'https://blsa.thinklead.co.za',
            //'businessleadership.org.za': 'https://blsa.thinklead.co.za',
            //'businessleadership@': 'https://blsa.thinklead.co.za',
            //'businessleadership': 'https://blsa.thinklead.co.za',
            'harmony': 'https://harmony.thinklead.co.za',
            'harmony@': 'https://harmony.thinklead.co.za'
          }

          return corporateDomains[y]
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Only update logo if company data has actually changed
    if (this.props.companydata && this.props.companydata !== prevProps.companydata) {
      if (this.props.companydata.logo) {
        this.setState({ logoLoaded: true });
      }
    }
  }

  render() {
    const { companylogo, logoLoaded } = this.state
    const { classes, companydata } = this.props
    
    // Determine which logo to use
    let logoSrc = deflogo;
    
    // If we have loaded company logo from state, use it
    if (companydata && companydata.logo) {
      logoSrc = companydata.logo;
    } 
    // Else use the one we determined from URL
    else if (companylogo) {
      logoSrc = companylogo;
    }
    
    return (
      <div {...this.props}>
        <img
          className={classes.root}
          src={logoSrc}
          alt="ME-VISION Logo"
          title="Click to go to Dashboard"
          onClick={this.handleLogoClick}
          onError={(e) => {
            // Fallback to default logo if loaded logo fails
            e.target.src = deflogo;
          }}
        />
      </div>
    )
  }
}

Companylogo.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}

const mapStateToProps = state => {
  return {
    companydata: state.loggedInCompany.companydata
  }
}

const CompanylogoStyled = withStyles(styles, { withTheme: true })(Companylogo)

export default withRouter(connect(
  mapStateToProps,
  null
)(CompanylogoStyled))
